import { GET_GST_URL, UPDATE_GST_DETAILS_URL } from "../../api";
import axiosInstance from "../../axiosInstance";

export const getGSTDetails = () => onResponse => {
    try {
        axiosInstance.get(GET_GST_URL)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};

export const updateGSTDetails = (props) => onResponse => {
    try {
        axiosInstance.post(UPDATE_GST_DETAILS_URL, props.formData)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};